import { createContext, useContext } from "react";

import type { DropdownInternals } from "../types";

const DropdownContext = createContext<DropdownInternals | null>(null);

const useDropdownContext = (): DropdownInternals =>
  useContext(DropdownContext) as DropdownInternals;

export { useDropdownContext, DropdownContext };
